<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <!--i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">pets</i-->
                            <img src="@/assets/img/animal.svg" class="opacity-10 text-white" style="width: 28px;margin-top: 17px;" />
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('animal.My_animals') }}</h6>
                        <div class="row" :style="userRoleName != 'Keeper' ? { marginTop: '-30px' } : {}">
                            <div class="col-lg-2">
                            </div>
                            <div class="col-lg-10">
                                <div class="d-flex justify-content-end align-items-center gap-2">
                                    <a :href="templateUrl" download class="download-link text-success" v-if="!['Keeper', 'Inspector'].includes(userRoleName)">
                                        <i class="material-symbols-rounded">download</i>
                                        <span class="underline-text">Download Template</span>
                                    </a>
                                    
                                    <div class="btn-group" v-if="userRoleName == 'Admin' || userRoleName == 'AssociationAdmin'" style="margin-top: 15px;">
                                        <span class="btn btn-sm bg-gradient-success text-nowrap" style="width: 150px;">
                                            {{ $t('settings.Association') }}
                                        </span>
                                        <button type="button" class="btn btn-sm bg-gradient-success dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span class="visually-hidden">{{ $t('settings.Select_association') }}</span>
                                        </button>

                                        <ul class="dropdown-menu dropdown-menu-end custom-association-dropdown">
                                            <li>
                                                <input
                                                    ref="searchInput" v-model="searchQuery" type="text" class="form-control form-control-sm" :placeholder="$t('animal.Search_UBN')" style="display: block !important;"/>
                                                <span
                                                    class="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" style="cursor: pointer;" @click="clearAssociationSelection">
                                                    &times;
                                                </span>
                                            </li>
                                            <li><hr class="dropdown-divider" /></li>                                        
                                            <!-- Associations and UBNs -->
                                            <li v-for="assoc in filteredAssociations" :key="assoc.associationId">
                                                <span class="dropdown-item text-bold text-dark fs-12">
                                                    {{ assoc.abbreviation || assoc.name }}
                                                </span>
                                                <ul class="list-unstyled ms-3">
                                                    <li
                                                        v-for="ubn in assoc.ubns"
                                                        :key="ubn.locationId"
                                                        @click="selectUbn(assoc.associationId, assoc.abbreviation || assoc.name, ubn.locationId, ubn.ubn)"
                                                        class="dropdown-item  fs-12"
                                                    >
                                                        {{ ubn.ubn }}
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>

                                    <label
                                        class="btn btn-sm btn-success m-0 d-flex align-items-center"
                                        :class="{ 'disabled-look': isUploading || !associationId }"
                                        :disabled="isUploading || !associationId"
                                        @mouseenter="hover = true"
                                        @mouseleave="hover = false"
                                        @click="startUpload"
                                        style="transition: background 0.3s ease;"
                                        v-if="userRoleName == 'Keeper' || userRoleName == 'AssociationAdmin' || userRoleName == 'Admin'"
                                    >
                                        <i v-if="!isUploading" class="material-symbols-rounded text-white me-1" style="font-size: 16px;">upload</i>
                                        <div v-if="isUploading" class="spinner-border spinner-border-sm text-white me-1" role="status"></div>
                                        <span>{{ isUploading ? $t('eartag.Uploading') : $t('eartag.Upload_File') }}</span>
                                        <input type="file" accept=".xls,.xlsx" @change="handleFileUpload" hidden />
                                    </label>

                                    <div class="btn-group" v-if="userRoleName == 'Keeper'" style="margin-top: 15px;">
                                        <router-link
                                            :to="associationId ? { name: 'New Animal', params: { id: associationId }, query: { ubnId: ubnId } } : ''"
                                            class="btn btn-sm bg-gradient-success text-nowrap"
                                            :class="{ disabled: !associationId }"
                                            style="width: 150px;"
                                        >
                                            {{ $t('animal.Add_animal') }}
                                        </router-link>
                                    </div>
                                    
                                    <div class="btn-group" v-if="!['Keeper', 'Inspector'].includes(userRoleName)" style="margin-top: 15px;">
                                        <router-link
                                            :to="associationId ? { name: 'New Animal', params: { id: associationId }, query: { ubnId: ubnId } } : '#'"
                                            class="btn btn-sm bg-gradient-success text-nowrap"
                                            :class="{ disabled: !associationId || !ubnId }"
                                            style="width: 150px;"
                                        >
                                            {{ $t('animal.Add_animal') }}
                                        </router-link>
                                    </div>
                                </div>                                
                                <div class="d-flex justify-content-end" v-if="userRoleName == 'Admin' || userRoleName == 'AssociationAdmin'">
                                    <span class="text-sm text-danger" v-if="!associationId">
                                        {{ $t('settings.Select_association_to_proceed') }}
                                    </span>
                                    <span class="text-sm text-success" v-if="associationId">
                                        {{ $t('settings.Association_selected') }}: {{ associationName }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end align-items-center gap-2 mb-2" v-if="['Keeper', 'AssociationAdmin'].includes(userRoleName)">
                        <div class="btn-group btn-group-sm me-4" role="group" aria-label="Status filter">                            
                            <button type="button"
                                    class="btn"
                                    :class="statusFilter==='all' ? 'btn-success' : 'btn-outline-success'"
                                    @click="statusFilter='all'">
                            {{ $t('common.All') }} ({{ counts.all }})
                            </button>
                            <button type="button"
                                    class="btn"
                                    :class="statusFilter==='active' ? 'btn-success' : 'btn-outline-success'"
                                    @click="statusFilter='active'">
                            {{ $t('common.Active') }} ({{ counts.active }})
                            </button>
                            <button type="button"
                                    class="btn"
                                    :class="statusFilter==='inactive' ? 'btn-success' : 'btn-outline-success'"
                                    @click="statusFilter='inactive'">
                            {{ $t('common.Inactive') }} ({{ counts.inactive }})
                            </button>
                        </div>
                    </div>
                    <div class="table-responsive" :class="{ 'mt-5': ['Inspector', 'Admin'].includes(userRoleName) }" ref="tableWrapper">
                        <div
                            v-if="isServerPaging"
                            class="d-flex align-items-center gap-2 ms-3 mb-3"
                        >

                            <input
                                v-model="searchText"
                                type="text"
                                class="form-control search-txt"
                                style="max-width: 350px;"
                                :placeholder="$t('datatable.Search')"
                                @keyup.enter="handleSearch"
                            />

                            <button
                                class="btn btn-sm bg-gradient-success mb-0"
                                @click="handleSearch"
                            >
                                {{ $t('common.Search') }}
                            </button>

                        </div>
                        <table id="animal-list" class="table table-flush" ref="animalTable" :key="tableKey + '-' + statusFilter">
                            <thead class="thead-light">
                                <tr>
                                    <th v-for="col in activeColumns" :key="col.key">
                                        <p class="mb-0 text-xs font-weight-bold">{{ col.label }}</p>
                                    </th>                                    
                                    <th data-sortable="false"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="animal in filteredAnimals" :key="`a-${animal.id}`" 
                                    :class="{
                                        'dead-animal-row': animal.isDied,
                                        'transferred-animal-row': animal.isTransferred
                                    }"
                                >
                                    <td v-for="col in activeColumns" :key="`c-${col.key}`">
                                        <span v-if="col.key === 'name' && animal.isDied" class="badge bg-danger">
                                            <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">church</i>
                                        </span>
                                        <span v-if="col.key === 'name' && animal.isTransferred" class="badge bg-warning">
                                            <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">output</i>
                                        </span>
                                        {{ animal[col.key] }}
                                    </td>
                                    <td>
                                        <div class="float-end">
                                            <button v-if="!['Keeper', 'Inspector'].includes(userRoleName)" :data-id="animal.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 certificate-button" style="margin-right: 10px !important;" :title="$t('animal.Download_certificate')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">download</i>
                                            </button>
                                            <button :data-id="animal.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 pedigree-button" style="margin-right: 10px !important;" :title="$t('animal.Pedigree1')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">family_history</i>
                                            </button>
                                            <button :data-id="animal.id" 
                                                :hidden="animal.isDied || animal.isTransferred"
                                                class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                            </button>
                                            <!--
                                            <button :data-id="animal.id" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" :title="$t('common.Delete')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                            </button>
                                            -->
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> 
                    <div
                        v-if="isServerPaging && totalPages > 1"
                        class="d-flex justify-content-end align-items-center gap-2 mt-3 mb-3 px-3"
                    >
                        <!-- Previous -->
                        <button
                            v-if="currentPage > 1"
                            class="btn btn-sm btn-outline-success rounded-pill mb-0"
                            style="min-width:40px;height:40px;padding:0 12px;"
                            @click="goToPage(currentPage - 1)"
                        >
                            ‹
                        </button>

                        <!-- First Page -->
                        <button
                            v-if="visiblePages[0] > 1"
                            class="btn btn-sm btn-outline-success rounded-pill mb-0"
                            style="min-width:40px;height:40px;padding:0 12px;"
                            @click="goToPage(1)"
                        >
                            1
                        </button>

                        <!-- Left dots -->
                        <span
                            v-if="visiblePages[0] > 2"
                            class="px-1"
                        >
                            ...
                        </span>

                        <!-- Visible Pages -->
                        <button
                            v-for="page in visiblePages"
                            :key="page"
                            class="btn btn-sm rounded-pill mb-0"
                            :class="currentPage === page
                                ? 'btn-success'
                                : 'btn-outline-success'"
                            style="min-width:40px;height:40px;padding:0 12px;"
                            @click="goToPage(page)"
                        >
                            {{ page }}
                        </button>

                        <!-- Right dots -->
                        <span
                            v-if="visiblePages[visiblePages.length - 1] < totalPages - 1"
                            class="px-1"
                        >
                            ...
                        </span>

                        <!-- Last Page -->
                        <button
                            v-if="visiblePages[visiblePages.length - 1] < totalPages"
                            class="btn btn-sm btn-outline-success rounded-pill mb-0"
                            style="min-width:40px;height:40px;padding:0 12px;"
                            @click="goToPage(totalPages)"
                        >
                            {{ totalPages }}
                        </button>

                        <!-- Next -->
                        <button
                            v-if="currentPage < totalPages"
                            class="btn btn-sm btn-outline-success rounded-pill mb-0"
                            style="min-width:40px;height:40px;padding:0 12px;"
                            @click="goToPage(currentPage + 1)"
                        >
                            ›
                        </button>

                    </div>        
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import axios from 'axios';
//import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";

export default {
    name: 'Myanimal_index_page',    
    components: {
    },
    data() {
        return {
            templateUrl: "/templates/VeeBoek-importanimal-template.xlsx",
            associationId: '',
            associationName: '',
            ubnId: '',
            associations: [],
            animals: [],
            gets: [],            
            dataTableInstance: null,
            choicesInstanceAssociation: null,
            searchQuery: '',
            isUploading: false,
            hover: false,
            animalListClickBound: false,
            tableKey: 0,

            currentPage: 1,
            pageSize: 100,
            totalCount: 0,
            hasMoreData: true,
            isServerPaging: false,

            searchText: '',

            // store only the keys in data()
            keeperColumnKeys: ['tagNumber', 'studbookNumber', 'birthDate', 'gender', 'name', 'breedName', 'breederName'],
            normalColumnKeys: ['ubn', 'tagNumber', 'studbookNumber', 'name', 'breedName', 'gender', 'birthDate', 'keeperName'],
            statusFilter: 'active', // 'all' | 'active' | 'inactive'
        }
    },
    computed: {        
        filteredAnimals() {
            if (!Array.isArray(this.animals)) return [];
            switch (this.statusFilter) {
                case 'active':
                    return this.animals.filter(a => a.isActive === true);
                case 'inactive':
                    return this.animals.filter(a => a.isActive === false);
                default:
                    return this.animals;
            }
        },
        counts() {
            const all = Array.isArray(this.animals) ? this.animals.length : 0;
            const active = Array.isArray(this.animals) ? this.animals.filter(a => a.isActive === true).length : 0;
            const inactive = all - active;
            return { all, active, inactive };
        },
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        // map keys -> { key, label } with translations (reactive to locale)
        keeperColumns() {
            return this.keeperColumnKeys.map(k => ({ key: k, label: this.colLabel(k) }));
        },
        normalColumns() {
            return this.normalColumnKeys.map(k => ({ key: k, label: this.colLabel(k) }));
        },
        activeColumns() {
            return this.userRoleName === 'Keeper' ? this.keeperColumns : this.normalColumns;
        },
        filteredAssociations() {
            if (!this.searchQuery) return this.associations;

            return this.associations
                .map(assoc => {
                    const filteredUbns = assoc.ubns.filter(u => u.ubn.includes(this.searchQuery));
                    return { ...assoc, ubns: filteredUbns };
                })
                .filter(assoc => assoc.ubns.length > 0);
        },
        totalPages() {
            return Math.ceil(this.totalCount / this.pageSize);
        },
        visiblePages() {

            const pages = [];

            let start = Math.max(1, this.currentPage - 1);
            let end = Math.min(this.totalPages, this.currentPage + 1);

            if (this.currentPage === 1) {
                end = 3;
            }

            if (this.currentPage === this.totalPages) {
                start = this.totalPages - 2;
            }

            start = Math.max(start, 1);

            for (let i = start; i <= end; i++) {
                if (i > 0 && i <= this.totalPages) {
                    pages.push(i);
                }
            }

            return [...new Set(pages)];
        }
    },
    async mounted() {        
        try {     
            const { matingId, associationId, genderId, ubnId } = this.getFetchParams();

            this.$store.commit('setShowLoading', true);            
            
            await this.fetchAllAssociationData();

            //await this.fetchAllAnimals(matingId, associationId, genderId, ubnId);
            this.isServerPaging = this.userRoleName !== 'Keeper';

            await this.fetchAllAnimals(
                matingId,
                associationId,
                genderId,
                ubnId
            );
            
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    watch: {
        statusFilter: {
            immediate: false,
            async handler () {
            // 1) Destroy plugin to return DOM control to Vue
            if (this.dataTableInstance) {
                try { this.dataTableInstance.destroy(); } catch { console.log('Error') }
                this.dataTableInstance = null;
            }

            // 2) Bump key so Vue recreates the <table> fresh
            this.tableKey++;

            // 3) Wait for DOM, then re-init the plugin on the fresh node
            await this.$nextTick();
            await this.initAnimalDataTable();
            }
        },
    
        // whenever animals list changes (after upload or initial fetch)
        animals: {
            handler: async function () {
                await this.initAnimalDataTable();
            },
            deep: false
        }
    },
    methods: {
        async handleSearch() {

            this.currentPage = 1;

            const {
                matingId,
                associationId,
                genderId,
                ubnId
            } = this.getFetchParams();

            await this.fetchAllAnimals(
                matingId,
                associationId,
                genderId,
                ubnId
            );
        },
        async goToPage(page) {

            if (page < 1 || page > this.totalPages)
                return;

            this.currentPage = page;

            const { matingId, associationId, genderId, ubnId } =
                this.getFetchParams();

            await this.fetchAllAnimals(
                matingId,
                associationId,
                genderId,
                ubnId
            );
        },
        
        // central place to translate labels per key        
        colLabel(key) {
            const map = {
                studbookNumber: this.$t('animal.Studbook_number'),
                tagNumber: this.$t('animal.Tag_number'),
                ubn: this.$t('animal.UBN'),
                animalNumber: this.$t('animal.Registration_No'),
                name: this.$t('animal.Name'),
                breedName: this.$t('animal.Breed'),
                gender: this.$t('animal.Gender'),
                birthDate: this.$t('animal.Date_of_birth'),
                breederName: this.$t('animal.Breeder'),
                keeperName: this.$t('animal.Keepername'),
            };
            return map[key] ?? key;
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        },
        async initAnimalDataTable() {

            // Bind click handler ONCE for ALL roles
            if (!this.animalListClickBound && this.$refs.tableWrapper) {

                this.$refs.tableWrapper.addEventListener('click', (event) => {

                    const targetElement = event.target.closest('[data-id]');

                    if (!targetElement)
                        return;

                    const id = targetElement.getAttribute('data-id');

                    if (!id)
                        return;

                    if (event.target.closest('.edit-button')) {

                        this.$router.push({
                            name: 'Edit Animal',
                            params: { id }
                        });

                    } else if (event.target.closest('.pedigree-button')) {

                        this.$router.push({
                            name: 'Animal Pedigree',
                            params: { id }
                        });

                    } else if (event.target.closest('.certificate-button')) {

                        this.downloadCertificate(id);

                    } else if (event.target.closest('.delete-button')) {

                        this.deleteAnimalModal(id);
                    }
                });

                this.animalListClickBound = true;
            }

            // ONLY Keeper uses simple-datatables
            if (this.userRoleName !== 'Keeper') {
                return;
            }

            // Destroy previous instance safely
            if (this.dataTableInstance) {

                try {
                    this.dataTableInstance.destroy();
                } catch {
                    console.log('could not destroy datatable instance');
                }

                this.dataTableInstance = null;

                // Force Vue to render fresh table
                this.tableKey++;

                await this.$nextTick();
            }

            // Wait for DOM render
            await this.$nextTick();
            await new Promise(requestAnimationFrame);

            const tableEl = this.$refs.animalTable;

            if (!tableEl || !tableEl.parentNode) {
                return;
            }

            // Detect columns
            const ths = tableEl.tHead?.rows?.[0]?.cells || [];

            const thCount = ths.length;

            const actionColIndex =
                thCount > 0
                    ? thCount - 1
                    : -1;

            const columns = Array.from(
                { length: thCount },
                (_, i) => ({
                    select: i,
                    sortable: i !== actionColIndex
                })
            );

            // Init simple-datatables
            this.dataTableInstance = new DataTable(tableEl, {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                columns,

                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search')
                }
            });
        },
        getFetchParams() {
            const role = this.$store.state.roleName;

            const matingId = this.$route.query.matingId || null;
            const genderId = this.$route.query.genderId || null;

            let associationId = this.$route.query.associationId || null;
            let ubnId = this.$route.query.ubnId || null;

            if (role === 'Keeper') {
                // force keeper context
                if (this.$store.state.keeperAssociationId) associationId = this.$store.state.keeperAssociationId;
                if (this.$store.state.keeperLocationId) ubnId = this.$store.state.keeperLocationId;

                this.associationId = associationId;
                this.ubnId = ubnId;
                console.log(this.associationId);
                console.log(associationId);
            } else if (role === 'AssociationAdmin') {
                if (this.$store.state.associationAdminAssociationId) {
                    associationId = this.$store.state.associationAdminAssociationId;
                    this.associationId = associationId;
                }
            }

            return { matingId, associationId, genderId, ubnId };
        },
        async handleFileUpload(event) {

            this.$store.commit('setShowLoading', true);

            const file = event.target.files[0];
            if (!file) {
                this.$showError('errors.No_file_selected_for_upload');
                return;
            }

            // Validate Excel file type
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel'                                           // .xls
            ];

            if (!allowedTypes.includes(file.type)) {
                this.$showError('errors.Only_excel_files_allowed');
                return;
            }

            this.isUploading = true;
            const formData = new FormData();
            formData.append('file', file);
            formData.append('associationId', this.associationId);

            try {
                const response = await axios.post('animal/import', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                const result = response.data;

                if (result.success) {
                    //this.$showSuccess('errors.Success_animals_uploaded_successfully');
                    this.$showSuccess(result.message);

                    const { matingId, associationId, genderId, ubnId } = this.getFetchParams();
                    this.fetchAllAnimals(matingId, associationId, genderId, ubnId);
                }
            } catch (error) {
                const errorMessage = error.response?.data?.message || error.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.isUploading = false;
                this.$store.commit('setShowLoading', false);
            }
        },
        focusSearchInput() {
            this.$nextTick(() => {
            if (this.$refs.searchInput) {
                this.$refs.searchInput.focus();
            }
            });
        },
        clearAssociationSelection() {
            this.associationId = '';
            this.ubnId = '';
            this.searchQuery = '';
        },
        selectUbn(associationId, associationName, ubnId, ubn) {
            this.associationId = associationId;
            this.associationName = associationName + ' - ' + ubn;
            this.ubnId = ubnId;
        },
        async fetchAllAnimals(matingId, associationId, genderId, ubnId) {
            try {

                this.$store.commit('setShowLoading', true);

                const isKeeper = this.$store.state.roleName === 'Keeper';

                const response = await axios.get("Animal/getallhistory", {
                                params: {
                                    matingId,
                                    associationId,
                                    genderId,
                                    ubnId,
                                    isKeeper,
                                    pageNumber: this.currentPage,
                                    pageSize: this.pageSize,
                                    searchText: this.searchText
                                }})

                this.gets = response.data;

                if (this.gets.success) {
                    if(this.gets.count > 0)
                    {
                        //this.animals = this.gets.data;
                        //this.animals = this.gets.data.map(a => ({
                        //    ...a,
                        //    birthDate: this.formatDate(a.birthDate)
                        //}))
                        //.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));

                        this.animals = this.gets.data.map(a => ({
                            ...a,
                            birthDate: this.formatDate(a.birthDate)
                        }));

                        this.totalCount = this.gets.count;

                        this.hasMoreData =
                            (this.currentPage * this.pageSize) < this.totalCount;
                    } else {
                        this.$showSuccess('errors.Success_no_animal_found');
                    }
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }       
        },
        async fetchAllAssociationData() {
            try {
                const response = await axios.get("association/getassociationswithubns");
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    this.associations = result.data;
                    if (this.associationId) {                        
                        const selectedAssociation = this.associations.find(a => a.associationId == this.associationId);
                        console.log("Selected Association:", selectedAssociation);
                        if (selectedAssociation) {
                            this.associations = [selectedAssociation];
                            
                        }
                    }
                }
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        async deleteAnimalModal(id) {   
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {                        
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("Animal/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {
                                    const fetchResponse = await axios.get("Animal/getall");
                                    const fetchResult = fetchResponse.data;

                                    if (fetchResult.success) {
                                        this.animals = fetchResult.data
                                            .map(a => ({ ...a, birthDate: this.formatDate(a.birthDate) }))
                                            .sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));

                                        // Destroy + reinit to avoid parentNode null
                                        if (this.dataTableInstance) {
                                            try { this.dataTableInstance.destroy(); } catch { console.log('Error')}
                                            this.dataTableInstance = null;
                                        }
                                        this.tableKey++;
                                        await this.$nextTick();
                                        await this.initAnimalDataTable();

                                        this.$showSuccess('errors.Success_record_is_deleted_successfully');
                                    } else {
                                        throw new Error('Failed to fetch updated animal list.');
                                    }
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                                }
                            } else {                                    
                                this.$showError('errors.Contact_system_admin');
                            }                            
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                });            
        }, 
        async downloadCertificate(id) {
            try {
                this.$store.commit('setShowLoading', true);

                const formData = new FormData();
                formData.append("animalId", id);

                const response = await axios.post(
                    "Animal/downloadcertifiate",
                    formData,
                    {
                        responseType: "blob"
                    }
                );

                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = url;
                link.download = "Zootechnisch_Certificaat.docx";
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

            } catch (e) {
                const errorMessage =
                    e.response?.data ||
                    e.message ||
                    this.$t('errors.Something_went_wrong');

                this.$showError(
                    `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        }
     
    }
}
</script>
<style scoped>
    ::v-deep .choices {
        width: auto !important;
        min-width: 270px;
    }
    .dead-animal-row {
        background-color: #f8d7da !important; /* light red */
        color: #721c24; /* dark red text */
    }
    .transferred-animal-row {
        background-color: #fdd199 !important;
        color: #643800;
    }
    .download-link {
        display: inline-flex;
        align-items: center; /* vertically centers icon & text */
        gap: 4px;            /* spacing between icon and text */
        text-decoration: none; /* prevent underline on whole link */
    }
    .disabled-look {
        opacity: 0.65;
        pointer-events: none;
    }
    .underline-text {
        text-decoration: underline;
        text-underline-offset: 2px;
    }
    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    .fs-12 {
        font-size: 12px !important;
    }
    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    .search-txt {
        max-width: 350px;
        border: 1px solid #d2d2d2;
        font-size: 0.875rem;
        color: #495057;
        border-radius: .375rem;
        padding: 6px 12px;
    }

    .search-txt:focus {
        border: 1px solid #4ca750 !important;
        box-shadow: none !important;
        outline: none !important;
    }
</style>